import React from 'react'
import { NumericFormat } from 'react-number-format'

const DetalleFacturacion = () => {
    return (
        <form className="text-start" >
            <div className="row">
                <div className="col-md">
                    <div className="light-font">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb white mb-0 m-2">
                                <li className="breadcrumb-item"><a className="black-text">Carrito</a></li>
                                <li className="breadcrumb-item font-weight-bold">Detalles de Facturación</li>
                                <li className="breadcrumb-item ">Envio</li>
                                <li className="breadcrumb-item ">Pago</li>
                                <li className="breadcrumb-item ">Estado de la orden</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-6 detalle-facturacion-container'>
                    <p className="h4 mb-3 font-weight-bold">Detalles de facturación</p>
                    <div className='row'>
                        <div className='col-md'>
                            <label>Nombre *</label>
                            <input type="text" className="form-control mb-2 rounded-0" placeholder="Nombre" />
                        </div>
                        <div className='col-md'>
                            <label>Apellidos *</label>
                            <input type="text" className="form-control mb-2 rounded-0" placeholder="Apellidos" />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md'>
                            <label>Cedula *</label>
                            <input type="text" className="form-control mb-2 rounded-0" placeholder="Cedula" />
                        </div>
                    </div>
                </div>
                <div className='col-md detalle-facturacion-container ml-0'>
                    <p className="h6 mb-3 font-weight-bold">TU ORDEN</p>
                    <hr />
                    <div className='row producto-facturacion '>
                        <div className='col-md-10 row mb-2'>
                            <div className="col-md-5">
                                <img src='https://i.ebayimg.com/thumbs/images/g/hSkAAOSw96leBoP0/s-l640.jpg' />
                            </div>
                            <div className="col-md descripcion">
                                <h6 className='font-weight-bold'>Lorem ipsum dolor sit amet consectetur adipisici</h6>
                                <p>1 x <NumericFormat value={10000} thousandSeparator prefix='$' displayType="text" /></p>
                            </div>
                        </div>
                        <div className='col-md text-right'>
                            <NumericFormat value={10000} thousandSeparator prefix='$' displayType="text" />
                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className="col-md-5">
                            Subtotal
                        </div>
                        <div className="col-md text-right">
                            <NumericFormat value={10000} thousandSeparator prefix='$' displayType="text" />
                        </div>
                    </div>
                    <div className='row '>
                        <div className="col-md-5">
                            Envio
                        </div>
                        <div className="col-md text-right">
                            <p>Envio gratuito</p>
                        </div>
                    </div>
                    <hr />
                    <div className='row mb-3'>
                        <div className="col-md-5 font-weight-bold">
                            TOTAL
                        </div>
                        <div className="col-md text-right font-weight-bold">
                            <NumericFormat value={10000} thousandSeparator prefix='$' displayType="text" />
                        </div>
                    </div>

                    <button className="btn btn-black btn-block mb-0" type="submit">PAGAR</button>

                </div>
            </div>
        </form>
    )
}

export default DetalleFacturacion